import React, { useEffect, useState } from 'react';
import { Table, Switch, Tag } from 'antd';
import { notification } from '../../AntdGlobal';
import { listUsers, updateUser, User } from '../../auth/api';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const UsersPage = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchUsers = async () => {
    setLoading(true);
    const res = await listUsers();
    if (res.ok) {
      setUsers(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string, record: User) => (
        <Switch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          checked={status === 'active'}
          onChange={async (checked) => {
            const newStatus = checked ? 'active' : 'disabled';
            const res = await updateUser(record.id, { status: newStatus });
            if (res.ok) {
              notification.success({ message: 'Success', description: 'Status updated', duration: 5 });
              fetchUsers();
            }
          }}
        />
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (ts: number) => new Date(ts * 1000).toLocaleString(),
    },
    {
      title: 'Last Login',
      dataIndex: 'last_login_at',
      key: 'last_login_at',
      render: (ts: number) => ts ? new Date(ts * 1000).toLocaleString() : '-',
    },
  ];

  return (
    <div>
      <Table dataSource={users} columns={columns} rowKey="id" loading={loading} />
    </div>
  );
};

export default UsersPage;
